/* 讀到一半的 LINE 諮詢小卡（inphic.taipei 先用；.me 版型預覽共用）
   - 讀者把「文章本體」讀到 50%（不是整頁 50%）才出現，晚 0.8 秒滑入，不打斷閱讀
   - 直接跳在頁面正中間，後面壓一層深藍半透明遮罩；點遮罩、按 ×、按 Esc 都能關。手機掃不到自己的螢幕，所以 QR 只給桌機，手機給一顆直接開 LINE 的按鈕
   - 每個工作階段只出現一次；按關閉之後三天內不再出現
   - 出現／點擊／關閉各送一個 GA4 事件 contact_popup_show／_click／_close（有 gtag 才送；2026-10-20 前是同一個事件名 contact_popup 帶 action 參數）
   - 自帶樣式，放在哪個站都不靠外部 CSS；用 window.INPHIC_POPUP 可以覆寫設定（lineUrl、account、qrPath＋qrSize 換成該站的 LINE 帳號與 QR）*/
(function () {
  if (window.__inphicPopupLoaded) return;
  window.__inphicPopupLoaded = true;

  var cfg = Object.assign({
    lineUrl: 'https://line.me/R/ti/p/@inphic',
    account: '@inphic',
    selectors: ['#article-content', 'article.editor', '.article-detail .editor', '.main-article__content', 'article'],
    ratio: 0.5,
    delay: 800,
    snoozeDays: 3,
    sessionKey: 'inphic_popup_shown',
    dismissKey: 'inphic_popup_dismissed',
    title: '讀到一半，有問題可以直接問',
    text: '把產品、每日產量與預算告訴我們，直接拿到機型建議與報價。',
    button: '用 LINE 詢問',
    hint: '手機掃描加入 LINE'
  }, window.INPHIC_POPUP || {});

  var QR_DEFAULT = 'M0 0.5h7m4 0h3m2 0h5m1 0h7M0 1.5h1m5 0h1m1 0h1m2 0h1m2 0h3m1 0h2m2 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m2 0h1m2 0h3m1 0h1m3 0h1m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m2 0h1m1 0h5m1 0h4m1 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m3 0h2m2 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m3 0h4m3 0h1m1 0h2m1 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M9 7.5h1m3 0h2m1 0h2m2 0h1M0 8.5h1m1 0h1m1 0h1m1 0h1m3 0h1m1 0h1m1 0h2m1 0h1m1 0h2m3 0h1m2 0h1M0 9.5h1m1 0h3m5 0h1m1 0h1m1 0h2m5 0h3m1 0h1m2 0h1M3 10.5h1m2 0h1m1 0h1m1 0h1m1 0h2m4 0h1m2 0h1m1 0h2m1 0h3M0 11.5h6m2 0h1m2 0h2m2 0h1m1 0h3m1 0h2m4 0h1M1 12.5h3m1 0h5m6 0h2m1 0h4m2 0h1m1 0h2M1 13.5h2m2 0h1m2 0h1m2 0h1m1 0h1m1 0h2m3 0h3m2 0h1m2 0h1M0 14.5h2m1 0h7m1 0h2m1 0h4m2 0h2m3 0h1m1 0h2M4 15.5h2m1 0h1m3 0h1m1 0h2m1 0h2m1 0h2m3 0h2m1 0h1M1 16.5h1m2 0h1m1 0h2m1 0h1m1 0h2m1 0h2m1 0h1m3 0h2m2 0h1m1 0h2M5 17.5h1m3 0h4m1 0h2m1 0h2m1 0h3m2 0h2m1 0h1M0 18.5h1m5 0h1m1 0h6m4 0h1m2 0h4m2 0h2M1 19.5h1m1 0h1m1 0h1m1 0h1m2 0h2m3 0h1m1 0h1m2 0h1m2 0h3m1 0h1M0 20.5h1m1 0h1m1 0h3m1 0h1m3 0h1m3 0h2m1 0h6M8 21.5h1m3 0h2m1 0h2m2 0h2m3 0h1m1 0h3M0 22.5h7m2 0h1m4 0h3m1 0h3m1 0h1m1 0h2m1 0h2M0 23.5h1m5 0h1m2 0h2m1 0h3m1 0h2m1 0h2m3 0h2m1 0h2M0 24.5h1m1 0h3m1 0h1m1 0h1m3 0h1m1 0h4m2 0h5m2 0h1M0 25.5h1m1 0h3m1 0h1m2 0h2m2 0h3m3 0h3m1 0h2m1 0h1M0 26.5h1m1 0h3m1 0h1m1 0h3m1 0h1m1 0h1m3 0h1m1 0h1m2 0h3m2 0h1M0 27.5h1m5 0h1m3 0h1m1 0h2m3 0h2m3 0h2m3 0h1M0 28.5h7m1 0h3m2 0h2m1 0h2m1 0h3m1 0h1m3 0h2';
  var qrSize = cfg.qrPath ? (cfg.qrSize || 25) : 29;
  var QR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + qrSize + ' ' + qrSize + '" shape-rendering="crispEdges" role="img" aria-label="LINE 官方帳號 ' + cfg.account + ' 的 QR code"><path stroke="#061f3d" d="' + (cfg.qrPath || QR_DEFAULT) + '"/></svg>';

  var CSS = '' +
    '.ip-veil{position:fixed;inset:0;z-index:2147483000;background:rgba(6,31,61,.55);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .35s cubic-bezier(.25,1,.5,1)}' +
    '.ip-veil.is-in{opacity:1}' +
    '.ip-veil.is-out{opacity:0;transition-duration:.2s}' +
    '.ip-pop{position:relative;width:560px;max-width:100%;background:#fff;color:#1f2a3f;border:1px solid #e3e8ef;border-radius:8px;box-shadow:0 40px 80px -24px rgba(6,31,61,.5),0 8px 20px -8px rgba(6,31,61,.2);font-family:"Noto Sans TC","PingFang TC","Microsoft JhengHei",system-ui,sans-serif;-webkit-font-smoothing:antialiased;overflow:hidden;transform:translateY(20px) scale(.96);transition:transform .45s cubic-bezier(.165,.84,.44,1)}' +
    '.ip-veil.is-in .ip-pop{transform:none}' +
    '.ip-pop *{box-sizing:border-box;margin:0}' +
    '.ip-pop .ip-bar{height:5px;background:linear-gradient(90deg,#7fd8d0,#9fd3f5 35%,#1a8ccf 70%,#061f3d)}' +
    '.ip-pop .ip-body{display:grid;grid-template-columns:200px minmax(0,1fr);gap:28px;padding:36px 36px 36px;align-items:center}' +
    '.ip-pop .ip-qr{width:200px;height:200px;padding:12px;border:1px solid #e3e8ef;border-radius:8px;background:#fff}' +
    '.ip-pop .ip-qr svg{display:block;width:100%;height:100%}' +
    '.ip-pop .ip-eyebrow{font-size:13px;font-weight:700;letter-spacing:.04em;color:#126da3;margin-bottom:8px}' +
    '.ip-pop h3{font-size:24px;line-height:1.35;font-weight:700;color:#061f3d}' +
    '.ip-pop p{font-size:15px;line-height:1.8;color:#4b5565;margin-top:10px}' +
    '.ip-pop .ip-hint{font-size:13px;color:#6b7686;margin-top:12px}' +
    '.ip-pop .ip-btn{display:none;align-items:center;justify-content:center;gap:8px;min-height:50px;margin-top:16px;padding:0 20px;border-radius:6px;background:#1a8ccf;color:#fff;font-size:16px;font-weight:700;text-decoration:none;line-height:1}' +
    '.ip-pop .ip-btn:hover{background:#1478b3}' +
    '.ip-pop .ip-close{position:absolute;top:14px;right:10px;width:40px;height:40px;border:0;background:transparent;color:#6b7686;font-size:26px;line-height:1;cursor:pointer;border-radius:6px}' +
    '.ip-pop .ip-close:hover{background:#eef5fc;color:#061f3d}' +
    '.ip-pop :focus-visible{outline:2px solid #1a8ccf;outline-offset:3px;border-radius:4px}' +
    '@media (max-width:640px){' +
      '.ip-veil{padding:16px}' +
      '.ip-pop{width:100%}' +
      '.ip-pop .ip-body{grid-template-columns:1fr;gap:0;padding:28px 22px 24px}' +
      '.ip-pop .ip-qr,.ip-pop .ip-hint{display:none}' +
      '.ip-pop h3{font-size:21px}' +
      '.ip-pop .ip-btn{display:inline-flex}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){.ip-veil,.ip-pop{transition:none}}';

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function track(action) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'contact_popup_' + action, { action: action, account: cfg.account, site: location.hostname }); } catch (e) {}
  }
  function store(kind, key, val) {
    try { var s = kind === 'session' ? sessionStorage : localStorage; if (val === undefined) return s.getItem(key); s.setItem(key, val); } catch (e) { return null; }
  }
  // 網址帶 ?popup=1 或 #popup 就強制出現（測試用）；同一個工作階段一篇文章只出現一次（不同文章各算一次）
  var force = /[?&#]popup(=1|$|&)/.test(location.search + location.hash);
  function suppressed() {
    if (force) return false;
    if (store('session', cfg.sessionKey + ':' + location.pathname)) return true;
    var d = Number(store('local', cfg.dismissKey) || 0);
    return d && (Date.now() - d) < cfg.snoozeDays * 864e5;
  }

  ready(function () {
    if (suppressed()) return;
    var body = null;
    for (var i = 0; i < cfg.selectors.length && !body; i++) body = document.querySelector(cfg.selectors[i]);
    if (!body) return;

    var shown = false, timer = 0;
    function progress() {
      var r = body.getBoundingClientRect();
      var top = r.top + window.pageYOffset, h = r.height;
      if (h < 200) return 0;
      // 文章很短（不到 1.2 個螢幕）就等讀到文末再算，避免一進頁就跳
      var need = h < window.innerHeight * 1.2 ? 0.95 : cfg.ratio;
      var seen = (window.pageYOffset + window.innerHeight - top) / h;
      return seen >= need ? 1 : 0;
    }
    function show() {
      if (shown) return;
      shown = true;
      window.removeEventListener('scroll', onScroll);
      var style = document.createElement('style');
      style.textContent = CSS;
      document.head.appendChild(style);
      var veil = document.createElement('div');
      veil.className = 'ip-veil';
      var el = document.createElement('div');
      el.className = 'ip-pop';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'LINE 諮詢');
      el.innerHTML = '<div class="ip-bar"></div>' +
        '<button type="button" class="ip-close" aria-label="關閉">×</button>' +
        '<div class="ip-body">' +
          '<div class="ip-qr">' + QR + '</div>' +
          '<div>' +
            '<div class="ip-eyebrow">LINE 官方帳號 ' + cfg.account + '</div>' +
            '<h3>' + cfg.title + '</h3>' +
            '<p>' + cfg.text + '</p>' +
            '<div class="ip-hint">' + cfg.hint + '</div>' +
            '<a class="ip-btn" href="' + cfg.lineUrl + '" target="_blank" rel="noopener">' + cfg.button + '</a>' +
          '</div>' +
        '</div>';
      veil.appendChild(el);
      document.body.appendChild(veil);
      store('session', cfg.sessionKey + ':' + location.pathname, '1');
      track('show');
      void veil.offsetWidth; // 先排版一次，再加 class，淡入的過渡才會跑（背景分頁 rAF 不會跑，不能靠它）
      veil.classList.add('is-in');
      el.querySelector('.ip-close').focus();
      function close(reason) {
        veil.classList.remove('is-in');
        veil.classList.add('is-out');
        setTimeout(function () { if (veil.parentNode) veil.parentNode.removeChild(veil); }, 250);
        document.removeEventListener('keydown', onKey);
        if (reason === 'close') { store('local', cfg.dismissKey, String(Date.now())); track('close'); }
      }
      function onKey(e) { if (e.key === 'Escape') close('close'); }
      el.querySelector('.ip-close').addEventListener('click', function () { close('close'); });
      veil.addEventListener('click', function (e) { if (e.target === veil) close('close'); });
      el.querySelector('.ip-btn').addEventListener('click', function () { track('click'); setTimeout(function () { close('click'); }, 400); });
      document.addEventListener('keydown', onKey);
    }
    function onScroll() {
      if (shown) return;
      if (progress() >= 1) { if (!timer) timer = setTimeout(show, cfg.delay); }
      else if (timer) { clearTimeout(timer); timer = 0; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
